import svgIconClasses from "@mui/material/SvgIcon/svgIconClasses";
import buttonClasses from "@mui/material/Button/buttonClasses";
import buttonGroupClasses from "@mui/material/ButtonGroup/buttonGroupClasses";
import { buttonIcon } from "../../styles/utils/button.module";
import { resolve } from "../../styles/utils/utils";
export const MuiButtonGroupTheme = (dt) => {
    const dropdownIcon = `.Pxl-Button-label .${svgIconClasses.root}`;
    const setBorder = (dt, path, vertical) => {
        const color = resolve(dt, path);
        return {
            "&:not(:last-of-type)": Object.assign({}, (vertical
                ? {
                    borderBottom: `1px solid ${color.default}`,
                }
                : {
                    borderRight: `1px solid ${color.default}`,
                })),
            "&:hover": {
                borderColor: color.hover,
            },
            "&:focus-visible": {
                borderColor: color.focus,
            },
            "&:active": {
                borderColor: color.pressed,
            },
            [`&[disabled], &.disabled, &.${buttonClasses.disabled}`]: {
                borderColor: color.disabled,
            },
        };
    };
    return {
        defaultProps: {
            disableElevation: true,
        },
        styleOverrides: {
            root: {
                [`.${buttonClasses.root}`]: {
                    borderRadius: 0,
                    "&[class]:is(:focus-visible, :hover, :active)": {
                        position: "relative",
                        zIndex: 1,
                    },
                },
                [`.${buttonClasses.startIcon}`]: {
                    marginLeft: 0,
                },
                [`.${buttonClasses.endIcon}`]: {
                    marginRight: 0,
                },
                [`.${buttonClasses.iconSizeSmall}`]: {
                    width: "auto",
                    height: "auto",
                    ".PixelIcon": {
                        width: dt.icon.size.small,
                        height: dt.icon.size.small,
                    },
                },
                [`.${buttonClasses.iconSizeMedium}, .${buttonClasses.iconSizeLarge}`]: {
                    width: "auto",
                    height: "auto",
                    ".PixelIcon": {
                        width: dt.icon.size.medium,
                        height: dt.icon.size.medium,
                    },
                },
                [`.${buttonClasses.sizeSmall}`]: {
                    height: dt.button.small,
                    paddingRight: dt.space.inline.xSmall2,
                    paddingLeft: dt.space.inline.xSmall2,
                    [dropdownIcon]: buttonIcon(dt.icon.size.small),
                },
                [`.${buttonClasses.sizeMedium}`]: {
                    height: dt.button.medium,
                    paddingRight: dt.space.inline.xSmall,
                    paddingLeft: dt.space.inline.xSmall,
                    [dropdownIcon]: buttonIcon(dt.icon.size.medium),
                },
                [`.${buttonClasses.sizeLarge}`]: {
                    height: dt.button.large,
                    paddingRight: dt.space.inline.small,
                    paddingLeft: dt.space.inline.small,
                    [dropdownIcon]: buttonIcon(dt.icon.size.medium),
                },
                [`&.${buttonGroupClasses.contained} .${buttonClasses.root}`]: {
                    borderColor: "transparent",
                },
                [`&.${buttonGroupClasses.contained}`]: {
                    [`&.${buttonGroupClasses.vertical}`]: {
                        [`.${buttonClasses.root}:not(:last-of-type)`]: {
                            borderBottom: `1px solid ${dt.color.onPrimary.key}`,
                            "&.MuiButton-containedInverted": {
                                borderBottom: `1px solid ${dt.cta.contained.color.text.inverted.default}`,
                            },
                        },
                    },
                    [`&:not(.${buttonGroupClasses.vertical})`]: {
                        [`.${buttonClasses.root}:not(:last-of-type)`]: {
                            borderRight: `1px solid ${dt.color.onPrimary.key}`,
                            "&.MuiButton-containedInverted": {
                                borderRight: `1px solid ${dt.cta.contained.color.text.inverted.default}`,
                            },
                        },
                    },
                },
                [`&.${buttonGroupClasses.text}`]: {
                    [`.${buttonClasses.root}[class][class]`]: {
                        "&:has(+ :focus-visible)": {
                            position: "relative",
                            zIndex: 2,
                        },
                    },
                    [`&.${buttonGroupClasses.vertical}`]: {
                        [`.${buttonClasses.textPrimary}`]: Object.assign({}, setBorder(dt.cta.outlined.color.border, ["primary"], true)),
                        [`.${buttonClasses.textSecondary}`]: Object.assign({}, setBorder(dt.cta.outlined.color.border, ["secondary"], true)),
                        [`.${buttonClasses.textError}`]: Object.assign({}, setBorder(dt.cta.outlined.color.border, ["signal", "error"], true)),
                        [`.${buttonClasses.textWarning}`]: Object.assign({}, setBorder(dt.cta.outlined.color.border, ["signal", "warning"], true)),
                        [`.${buttonClasses.textInfo}`]: Object.assign({}, setBorder(dt.cta.outlined.color.border, ["signal", "info"], true)),
                        [`.${buttonClasses.textSuccess}`]: Object.assign({}, setBorder(dt.cta.outlined.color.border, ["signal", "success"], true)),
                        ".MuiButton-textNeutral": Object.assign({}, setBorder(dt.cta.outlined.color.border, ["neutral"], true)),
                        ".MuiButton-textInverted": Object.assign({}, setBorder(dt.cta.outlined.color.border, ["inverted"], true)),
                    },
                    [`&:not(.${buttonGroupClasses.vertical})`]: {
                        [`.${buttonClasses.textPrimary}`]: Object.assign({}, setBorder(dt.cta.outlined.color.border, ["primary"])),
                        [`.${buttonClasses.textSecondary}`]: Object.assign({}, setBorder(dt.cta.outlined.color.border, ["secondary"])),
                        [`.${buttonClasses.textError}`]: Object.assign({}, setBorder(dt.cta.outlined.color.border, ["signal", "error"])),
                        [`.${buttonClasses.textWarning}`]: Object.assign({}, setBorder(dt.cta.outlined.color.border, ["signal", "warning"])),
                        [`.${buttonClasses.textInfo}`]: Object.assign({}, setBorder(dt.cta.outlined.color.border, ["signal", "info"])),
                        [`.${buttonClasses.textSuccess}`]: Object.assign({}, setBorder(dt.cta.outlined.color.border, ["signal", "success"])),
                        ".MuiButton-textNeutral": Object.assign({}, setBorder(dt.cta.outlined.color.border, ["neutral"])),
                        ".MuiButton-textInverted": Object.assign({}, setBorder(dt.cta.outlined.color.border, ["inverted"])),
                    },
                },
                [`&.${buttonGroupClasses.vertical} .${buttonClasses.root}`]: {
                    "&:first-of-type": {
                        borderTopLeftRadius: dt.button.shape.borderRadius,
                        borderTopRightRadius: dt.button.shape.borderRadius,
                    },
                    "&:last-of-type": {
                        borderBottomLeftRadius: dt.button.shape.borderRadius,
                        borderBottomRightRadius: dt.button.shape.borderRadius,
                    },
                },
                [`&:not(.${buttonGroupClasses.vertical}) .${buttonClasses.root}`]: {
                    "&:first-of-type": {
                        borderTopLeftRadius: dt.button.shape.borderRadius,
                        borderBottomLeftRadius: dt.button.shape.borderRadius,
                    },
                    "&:last-of-type": {
                        borderTopRightRadius: dt.button.shape.borderRadius,
                        borderBottomRightRadius: dt.button.shape.borderRadius,
                    },
                },
            },
        },
    };
};
